import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "./VirtualActivities.css";
import axios from "axios";

const VirtualActivities = (props) => {
  const { id } = useParams();

  const [allActivities, setAllActivities] = useState([]);

  useEffect(() => {
    props.actSidebar(false);
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_programs/get_all_activities", {})
      .then((res) => {
        if (res.data.responseData) {
          setAllActivities(res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
  }, [props, id]);

  return (
    <div>
      <div className="prog_det_top_hold vt_top">
        <div className="prog_det_title vt_title_reduce">Virtual Activities</div>
      </div>
      <div className="activities_container_vt">
        {allActivities.map((item, i) => (
          <Link to={"/virtual_builder/" + item.id}>
            <div className="single_activity_vt">
              <div
                style={{
                  backgroundImage: `url(${item.image})`,
                }}
                className="activity_image_vt"
              ></div>
              <div className="activity_name_vt">{item.name}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default VirtualActivities;
